// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DaR3","col":"styles_col__3jH1u"};